module.exports = __webpack_public_path__ + "static/Light-Pink-6282a76db061cd0ce9839f3df1ab87de.png";